import { getCurrentMonthAndYear } from '@components/common';
import {
  metaDescriptionArr,
  metaTitleArr,
  readValueUsingKey,
} from '@components/common/constant';
import { populateDynamicValues } from '@license-admin/boldfjcomponents';
import { getENVPath } from 'helper';
interface IProps {
  localization?: ILocalization;
  dynamicTitle?: string;
  dynamicValues?: Array<string>;
}

interface ILocalization {
  pageTitle: string;
  meta_keywords: string;
  meta_title: string;
  meta_description: string;
}

export const MetaTags = (props: IProps) => {
  const {
    localization = {} as ILocalization,
    dynamicValues = [],
    dynamicTitle = '',
  } = props;
  return (
    <>
      {localization && localization?.pageTitle && (
        <title>
          {localization.pageTitle.replace(
            /{title}/g,
            readValueUsingKey(metaTitleArr, dynamicTitle) || dynamicTitle
          ) || ''}
        </title>
      )}
      {localization.meta_description && (
        <meta
          name="description"
          content={
            readValueUsingKey(metaDescriptionArr, dynamicValues[0]) ||
            populateDynamicValues(
              localization.meta_description.replace(
                '{month} {year}',
                getCurrentMonthAndYear()
              ),
              dynamicValues
            )
          }
        />
      )}
      {localization.meta_keywords && (
        <meta
          name="keywords"
          content={populateDynamicValues(
            localization.meta_keywords,
            dynamicValues
          )}
        />
      )}
      {localization.meta_title && (
        <meta
          property="og:title"
          content={
            localization.pageTitle.replace(
              /{title}/g,
              readValueUsingKey(metaTitleArr, dynamicTitle) || dynamicTitle
            ) || ''
          }
        />
      )}
      {localization.meta_description && (
        <meta
          property="og:description"
          content={
            readValueUsingKey(metaDescriptionArr, dynamicValues[0]) ||
            populateDynamicValues(
              localization.meta_description.replace(
                '{month} {year}',
                getCurrentMonthAndYear()
              ),
              dynamicValues
            )
          }
        />
      )}
      <meta
        property="og:image"
        content={`${
          getENVPath().NEXT_PUBLIC_CONTENT_URL
        }/images/remote_co_og_image.png`}
      />
      <meta property="og:type" content="website" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    </>
  );
};
